import { Suspense, type ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { PageLoading } from '../components';

/** Centered card layout for sign-in and other public pages. */
export function PublicLayout() {
  return (
    <main id="main" className="auth-layout">
      <Suspense fallback={<PageLoading />}>
        <Outlet />
      </Suspense>
    </main>
  );
}

export function AuthCard({ brand, children }: { brand?: ReactNode; children: ReactNode }) {
  return (
    <div className="auth-card">
      {brand}
      <div className="card stack">{children}</div>
    </div>
  );
}
